import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function TheNeed() {
  const {
    t,
    tArray
  } = useLanguage();
  const stats = tArray<{
    number: string;
    label: string;
  }>('theNeed.stats');
  return <section className="py-24 md:py-32 bg-ivory relative" id="vision" data-id="element-165" data-mp="3w800g1xg9ct">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-166" data-mp="7yl1gs9n5l3s">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto mb-20" data-id="element-167" data-mp="3q5sct1kzb87n">
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-6" data-id="element-168" data-mp="1fdqxrswqnk3z">
            {t('theNeed.title1')}
            <br data-id="element-169" data-mp="1jfktrnvznzxt" />
            <span className="text-gold italic" data-id="element-170" data-mp="1je1eo0m2juxm">{t('theNeed.title2')}</span>
          </h2>
          <p className="text-navy/70 text-lg leading-relaxed" data-id="element-171" data-mp="39atotcvceq8j">
            {t('theNeed.description')}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-20" data-id="element-172" data-mp="34c8ozek068km">
          <div className="rounded-sm overflow-hidden shadow-2xl border border-gold/20 mb-6" data-id="element-173" data-mp="2lepq33r9e6bx">
            <img src="https://cdn.magicpatterns.com/uploads/nm2vvmbFNr7jJiMfCXYQ18/Gemini_Generated_Image_1prdd51prdd51prd.png" alt="Anand Karaj Center Exterior" className="w-full h-auto max-h-[600px] object-cover" data-id="element-174" data-mp="30b6wdgklcurm" />
          </div>
          <div className="bg-marble p-6 rounded-sm border border-gold/10 text-center max-w-4xl mx-auto shadow-sm" data-id="element-175" data-mp="am4pm4e5tbph">
            <p className="text-navy/80 text-base md:text-lg leading-relaxed italic" data-id="element-176" data-mp="hnrq6y40l8ty">
              {t('theNeed.imageCaption')}
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-177" data-mp="rmfw4yiq5xha">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className="bg-marble p-10 rounded-sm border border-gold/10 text-center flex flex-col justify-center min-h-[240px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(212,168,83,0.1)] transition-shadow duration-500" data-id="element-178" data-mp="wmc04xrf9owu" data-mpi={index}>
              <div className="text-5xl md:text-6xl font-heading text-saffron mb-4" data-id="element-179" data-mp="1yg59utdx8lig">
                {stat.number}
              </div>
              <div className="text-navy/80 uppercase tracking-widest text-sm font-medium" data-id="element-180" data-mp="1ugd22iwcqje5">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}